import React from "react";
import { toggle } from "../../../../util/common";
import { IPackage, IPackageProduct } from "../../../../store/protectionPlanService/idf/types";
import { IProduct } from "../../../../store/protectionPlanService/idf/types";
import parse from "html-react-parser";

interface IProps {
    index: number;
    product: IProduct;
    packageList?: IPackage[];
}

const IDFProtectionPlanGroup: React.FunctionComponent<IProps> = (props) => {
    const displayProduct = (productName: string) => {
        if (productName === "==cross==") {
            return (
                <div className="plan-icon">
                    <em className="las la-times" title="Not included in Package"></em> <span className="sr-only">Not Included</span>
                </div>
            );
        } else if (productName === "==tick==") {
            return (
                <div className="plan-icon">
                    <em className="las la-check-circle" title="Included in Package"></em> <span className="sr-only">Included</span>
                </div>
            );
        } else {
            return productName;
        }
    };

    return (
        <React.Fragment>
            <tr className={"service-group service-group-" + props.product.id} key={"product-" + props.index}>
                <th className="row-label" scope="row">
                    <div className="drawer-container">
                        <div className="drawer-header">
                            <button
                                aria-expanded="false"
                                className="btn-default btn-toggle btn-table-drawer"
                                id={"btn-feature-" + props.product.id + "-" + props.index}
                                onClick={() => {
                                    toggle("feature-" + props.product.id + "-" + props.index, "btn-feature-" + props.product.id + "-" + props.index);
                                }}
                            >
                                <span className="btn-toggle-status sr-only">Show</span>
                                <span className="btn-text">{parse(props.product.name!)}</span>
                            </button>
                        </div>
                        <div className="drawer-content" id={"feature-" + props.product.id + "-" + props.index} style={{ display: "none" }}>
                            <h3 className="sr-only">{props.product.name}</h3>
                            <p>{props.product.productDescription}</p>
                        </div>
                    </div>
                </th>
                {props.packageList &&
                    props.packageList.map((pkg, pkgIndex: number) => (
                        <React.Fragment key={["product-icon", props.product.id, props.index, pkgIndex].join("-")}>
                            <td className="row-cell">{displayProduct(pkg.products.find((it: IPackageProduct) => props.product.name === it.productName)?.icon!)}</td>
                        </React.Fragment>
                    ))}
            </tr>
        </React.Fragment>
    );
};

export default IDFProtectionPlanGroup;
